// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"style_closeIcon___u2C4"};